export const DEFAULT_USER_MESSAGE = '';
